import { Row } from 'react-table';
import stringNaturalCompare from 'string-natural-compare';

import { COLUMN_IDS, summarizeRowsAbove } from '../constants';
import { getGapForRows } from '.';

const getSortingGap = (row: Row<TrqkGapChannelAudio>): number => {
    if (row.subRows.length < summarizeRowsAbove) {
        return row.values?.[COLUMN_IDS.GAP] ?? 0;
    }

    return getGapForRows(row.subRows, false);
};

/**
 * Sort two rows by their persisted gap value. This is the difference between number of
 * detections for audio files that have been selected to be included in the report vs. the number of
 * performances for a given statement work. The `.include` property is used to check whether
 * detections should be included. This property is read-only in terms of the UI, so the sort order
 * is calculated from the state of the "original", i.e. persisted data.
 * @param rowA - first row to sort
 * @param rowB - second row to sort
 * @param columnId - current column ID
 * @param desc - whether to sort items in descending order
 * @returns number indicating which row to sort first
 */
export const sortByIncludedGap = (
    rowA: Row<TrqkGapChannelAudio>,
    rowB: Row<TrqkGapChannelAudio>,
    columnId: string,
    desc?: boolean,
): number => {
    const gapA = getSortingGap(rowA);
    const gapB = getSortingGap(rowB);

    let sortResult = 0;

    if (gapA < gapB) {
        sortResult = 1;
    }

    if (gapA > gapB) {
        sortResult = -1;
    }

    if (gapA === gapB) {
        sortResult = stringNaturalCompare(
            rowA.values?.[COLUMN_IDS.WORK_NAME]?.detectionTitle ?? '',
            rowB.values?.[COLUMN_IDS.WORK_NAME]?.detectionTitle ?? '',
        );
    }

    if (desc) {
        return -sortResult;
    }

    return sortResult;
};
